
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestteethaligners",
      function () {
        return require("private-next-pages/bestteethaligners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestteethaligners"])
      });
    }
  